var _path, _rect, _path2, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8048 10.1953L10.7476 9.13807L13.2144 8.78567L12.862 11.2525L11.8048 10.1953Z",
    stroke: "#526069",
    strokeWidth: 1.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60352,
    y: 12.868,
    width: 0.666667,
    height: 4.5124,
    transform: "rotate(-135 9.60352 12.868)",
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667H2V2H11.3333V6.66667",
    stroke: "#526069",
    strokeWidth: 1.33333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 4.33333,
    width: 4,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 6.99996,
    width: 2,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 9.66671,
    width: 2.66667,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLicense);
export default __webpack_public_path__ + "static/media/external_license.58af6653f7a1c7f53e5d663ca12f3bc4.svg";
export { ForwardRef as ReactComponent };